import { motion } from "framer-motion";

const CITIES = [
    "Miami",
    "Miami Beach",
    "Coral Gables",
    "Doral",
    "Kendall",
    "Homestead",
    "Aventura",
    "Hollywood",
    "Fort Lauderdale",
    "Weston",
    "Sunrise",
    "Plantation",
    "Coral Springs",
    "Pompano Beach",
    "Boca Raton",
    "Delray Beach",
    "Boynton Beach",
    "Wellington",
    "West Palm Beach",
    "Palm Beach Gardens",
    "Jupiter",
    "Palm Beach",
    "Lake Worth",
    "Royal Palm Beach",
];

export default function Coverage() {
    return (
        <section
            id="coverage"
            data-testid="coverage"
            className="relative bg-black py-24 md:py-40 border-t border-white/10"
        >
            <div className="px-6 md:px-16">
                <div className="grid grid-cols-12 gap-6 mb-14 md:mb-20">
                    <div className="col-span-12 md:col-span-2 font-mono text-[10px] tracking-[0.3em] uppercase text-white/50 pt-2">
                        [ Ch. 06 ]
                        <br />
                        Coverage
                    </div>
                    <div className="col-span-12 md:col-span-10">
                        <h2 className="font-display uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.88] tracking-tight">
                            All of{" "}
                            <span className="rainbow-text">South Florida.</span>
                            <br />
                            Every zip. Every wall.
                        </h2>
                        <p className="mt-8 max-w-xl font-mono text-sm text-white/60">
                            From the Keys to the Treasure Coast — if it's
                            south of I-4, we roll to it.
                        </p>
                    </div>
                </div>

                {/* City grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-px bg-white/10 border border-white/10">
                    {CITIES.map((c, i) => (
                        <motion.div
                            key={c}
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.1 }}
                            transition={{
                                duration: 0.5,
                                delay: i * 0.02,
                                ease: [0.19, 1, 0.22, 1],
                            }}
                            data-testid={`city-${i}`}
                            className="relative glass-chip p-5 md:p-6 group cursor-crosshair overflow-hidden"
                        >
                            <div className="absolute inset-0 rainbow-bg opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                            <div className="relative flex items-baseline gap-3 group-hover:text-black transition-colors">
                                <span className="font-mono text-[10px] tracking-[0.2em] uppercase opacity-40">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span className="font-display uppercase text-lg md:text-xl leading-none tracking-tight">
                                    {c}
                                </span>
                            </div>
                        </motion.div>
                    ))}
                </div>

                <div className="mt-8 font-mono text-[11px] tracking-[0.24em] uppercase text-white/40">
                    Don't see your city? Call — chances are we already paint
                    the block.
                </div>
            </div>
        </section>
    );
}
